import { createServerFn } from "@tanstack/react-start";
import { isUnlistedPagePath } from "../../../shared/src/page-paths";
import { readDocumentPage } from "./document.server";
import { publicationResponse, siteContext } from "./site.server";

export type { DocumentPageData } from "./document.server";

/**
 * What a route shows when its path has no authored page: Home, About and the feature pages have a
 * native page of their own ("native"); any other path is missing.
 */
export type MissingPage = "native" | "missing";

/** The authored page at a path, for a document request or a client navigation. */
export const loadDocumentPage = createServerFn({ method: "GET" })
  .validator((input: unknown) => {
    const { path, missing } = (input ?? {}) as { path?: unknown; missing?: unknown };
    if (typeof path !== "string" || !path.startsWith("/") || path.length > 250)
      throw new Error("Pass a page path.");
    if (missing !== "native" && missing !== "missing")
      throw new Error("Say what a missing page shows.");
    return { path: path.replace(/\/+$/, "") || "/", missing: missing as MissingPage };
  })
  .handler(async ({ data, context }) => {
    // The guide template and components have no address of their own: pages show them.
    if (isUnlistedPagePath(data.path))
      return data.missing === "native" ? { kind: "native" as const } : { kind: "missing" as const };
    const drate = await siteContext(context);
    const page = await readDocumentPage(drate, data.path);
    publicationResponse(drate);
    if (page.kind === "missing" && data.missing === "native") return { kind: "native" as const };
    return page;
  });
